import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import { toFrenchNumber } from "../../formatted/FormattedText";
import "react-calendar/dist/Calendar.css";
import HeaderWasteQualityPDF from "./HeaderWasteQualityPDF";
import { wasteQualityStyleSheet } from "../styles/wasteQualityStyleSheet";
import caracterisation from "../../../static/assets/caracterisation.png";
import bulb from "../../../static/assets/bulb.png";
import CoverWasteQualityPdf from "./CoverWasteQualityPDF";
import { WasteQualityImageComponent } from "./WasteQualityImageComponent";
import { WasteQualityFooter } from "./WasteQualityFooter";
import { useTranslation } from "react-i18next";
import userIcon from "../../../static/assets/user.png";
import closeIcon from "../../../static/assets/close-icon.png";
import {
  formattedDate,
  formattedTime,
} from "../../formatted/FormattedDateAndTime";
import { getEffectiveThresholdCm } from "../../../containers/characterization-2/characterizationDetails/constants/regulation";

const getCommentAuthorName = (author = {}) =>
  author.name ||
  `${author.firstName || ""} ${author.lastName || ""}`.trim() ||
  "";

const WasteQualityPDF = ({
  caracDatetime,
  corporationData,
  totalWasteMass,
  totalMassRecoverable,
  chartImageUrl,
  tableImageUrl,
  materialImageUrl,
  selectedNumberOfCycleMaterial,
  volumeImgData,
  outletImgData,
  tableOutletImgData,
  totalWasteVolume,
  totalVolumeRecoverable,
  temporalDataArray,
  container,
  totalWeight,
  clientName,
  clientCode,
  clientAddress,
  superContainer,
  wasteCategoryName,
  parentCategoriesList,
  characterizationOutlet,
  comments,
  chartRepImgData,
  tableRepImgData,
  characterizationType,
  characterizationComments,
  repDescriptionDatas,
  categoryMassOverLimit,
  characterizationVolumeAnalysis,
  characterizationMassAnalysis,
  characterizationSizeDistribution,
  sizeChartImgData,
  sizeMatrixImgData,
  sizeThreshold = 40,
}) => {
  const { t } = useTranslation();
  const sizeDistributionThresholdCm = getEffectiveThresholdCm(
    characterizationType,
    sizeThreshold,
  );

  const totalMassInOutlet = parentCategoriesList.reduce(
    (sum, item) => sum + item.massInOutlet,
    0,
  );
  const totalMassNotInOutlet = parentCategoriesList.reduce(
    (sum, item) => sum + item.massNotInOutlet,
    0,
  );
  const hasMassVisuals = Boolean(tableImageUrl || chartImageUrl);
  const hasVolumeVisuals = Boolean(volumeImgData);
  const hasObjectsVisuals = Boolean(materialImageUrl);
  const hasOutletVisuals = Boolean(tableOutletImgData || outletImgData);
  const hasRepChartVisuals = Boolean(chartRepImgData);
  const hasSizeDistributionVisuals = Boolean(
    sizeChartImgData || sizeMatrixImgData,
  );
  const supportsClassicVolumeAnalysis = !["1199", "EPR"].includes(
    characterizationType,
  );
  const supportsObjectsDistribution = !["1199", "EPR"].includes(
    characterizationType,
  );
  const showMassSection = characterizationMassAnalysis && hasMassVisuals;
  const showOutletSection = characterizationOutlet && hasOutletVisuals;
  const showVolumeSection =
    characterizationVolumeAnalysis &&
    supportsClassicVolumeAnalysis &&
    hasVolumeVisuals;
  const showObjectsSection =
    supportsObjectsDistribution &&
    (characterizationMassAnalysis || characterizationVolumeAnalysis) &&
    hasObjectsVisuals;
  const showCombinedDetailsPage = showVolumeSection || showObjectsSection;
  const showPrimaryAnalysisPage =
    characterizationType === "RHW" || showMassSection;
  const showEprSection =
    characterizationType === "EPR" &&
    hasRepChartVisuals &&
    characterizationMassAnalysis;
  const showSizeDistributionSection =
    characterizationSizeDistribution &&
    characterizationType === "classic" &&
    hasSizeDistributionVisuals;

  // Sécuriser le parsing de wasteCategoryName (peut être string JSON, string simple ou objet)
  let wasteCategoryNameParsed = null;
  if (wasteCategoryName) {
    if (typeof wasteCategoryName === "string") {
      try {
        const trimmed = wasteCategoryName.trim();
        // Ne parser en JSON que si la chaîne ressemble vraiment à du JSON
        const shouldParseJson =
          (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
          (trimmed.startsWith("[") && trimmed.endsWith("]"));
        const parsed = shouldParseJson ? JSON.parse(trimmed) : null;
        wasteCategoryNameParsed = parsed?.wasteCategoryName ?? null;
      } catch {
        // Si ce n'est pas du JSON valide, on l'utilise tel quel comme label
        wasteCategoryNameParsed = wasteCategoryName;
      }
    } else if (typeof wasteCategoryName === "object") {
      wasteCategoryNameParsed = wasteCategoryName?.wasteCategoryName ?? null;
    }
  }

  let pageCounter = 1;

  return (
    <Document>
      <Page size="A4">
        <CoverWasteQualityPdf
          caracDatetime={caracDatetime}
          corporationData={corporationData}
          clientName={clientName}
          container={container}
          totalWeight={totalWeight}
          clientCode={clientCode}
          clientAddress={clientAddress}
          wasteCategoryName={wasteCategoryNameParsed}
          characterizationType={characterizationType}
        >
          {" "}
        </CoverWasteQualityPdf>
        <WasteQualityFooter page={pageCounter++} cover={true} />
      </Page>
      {showPrimaryAnalysisPage && (
        <Page size="A4">
          <HeaderWasteQualityPDF
            caracDatetime={caracDatetime}
            logoUrl={corporationData.logoUrl}
          />
          <View style={{ height: "77%", marginTop: 10 }}>
            {characterizationType !== "RHW" && showMassSection && (
              <View style={wasteQualityStyleSheet.tableContent}>
                <View style={{ flex: 3 }}>
                  <Text
                    style={{
                      ...wasteQualityStyleSheet.ChartTitle,
                      marginBottom: 20,
                    }}
                  >
                    {characterizationType === "EPR"
                      ? `${t("Détail par")} ${t("REP")}`
                      : t("Résultats")}
                  </Text>
                  {/* <View style={wasteQualityStyleSheet.caracterisationAndStats}>
                  <View style={wasteQualityStyleSheet.caracterisationLogo}>
                    <Image src={caracterisation} />
                  </View>
                  <View style={{ marginRight: 2 }}>
                    <Text
                      style={wasteQualityStyleSheet.caracterisationContainer}
                    >
                      {selectedNumberOfCycleMaterial}
                    </Text>
                  </View>
                  <View>
                    <Text style={wasteQualityStyleSheet.caracterisationText}>
                      {t("contenant")}
                    </Text>
                    <Text style={wasteQualityStyleSheet.caracterisationText}>
                      {t("characterized")}
                    </Text>
                  </View>
                  </View> */}
                </View>
                <View style={{ flex: 7, alignItems: "flex-end" }}>
                  {characterizationType === "1199" &&
                    categoryMassOverLimit.length > 0 && (
                      <View style={wasteQualityStyleSheet.wrapper}>
                        <View style={wasteQualityStyleSheet.alertRow}>
                          <Image
                            src={closeIcon}
                            style={{ width: 12, marginRight: 3 }}
                          />
                          <Text style={wasteQualityStyleSheet.alertText}>
                            {t(
                              "Le contenant ne respecte pas les critères de conformité",
                            )}
                            .
                          </Text>
                        </View>
                        {categoryMassOverLimit.map((item, index) => (
                          <View
                            style={wasteQualityStyleSheet.categoryRow}
                            key={`${item.parentCategory}-${index}`}
                          >
                            <View style={wasteQualityStyleSheet.leftCol}>
                              <Text style={wasteQualityStyleSheet.categoryName}>
                                {item.parentCategory}
                              </Text>
                              <Text
                                style={wasteQualityStyleSheet.categoryPercent}
                              >
                                {toFrenchNumber(
                                  (item.massObjects / totalWasteMass) * 100,
                                  1,
                                )}
                                %
                              </Text>
                            </View>
                            <View style={wasteQualityStyleSheet.rightCol}>
                              <Text style={{ marginBottom: "5px" }}>
                                {t("Avec filière de recyclage")}:{" "}
                                <Text style={wasteQualityStyleSheet.boldValue}>
                                  {toFrenchNumber(
                                    (item.massInOutlet / totalWasteMass) * 100,
                                    1,
                                  )}
                                  %
                                </Text>
                              </Text>
                              <Text>
                                {t("Sans filière de recyclage")}:{" "}
                                <Text style={wasteQualityStyleSheet.boldValue}>
                                  {toFrenchNumber(
                                    (item.massNotInOutlet / totalWasteMass) *
                                      100,
                                    1,
                                  )}
                                  %
                                </Text>
                              </Text>
                            </View>
                          </View>
                        ))}
                      </View>
                    )}
                  <View
                    style={{
                      height: "300px",
                      width: "350px",
                      alignSelf: "flex-end",
                    }}
                  >
                    {characterizationType === "EPR"
                      ? tableRepImgData && (
                          <Image
                            src={tableRepImgData}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        )
                      : tableImageUrl && (
                          <Image
                            src={tableImageUrl}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        )}
                  </View>
                </View>
              </View>
            )}
            <View style={wasteQualityStyleSheet.chartContent}>
              <View style={{ flex: 3 }}>
                {characterizationType === "RHW" && (
                  <>
                    <Text
                      style={{
                        ...wasteQualityStyleSheet.ChartTitle,
                        marginBottom: 20,
                      }}
                    >
                      {t("Résultats")}
                    </Text>
                    <View
                      style={wasteQualityStyleSheet.caracterisationAndStats}
                    >
                      <View style={wasteQualityStyleSheet.caracterisationLogo}>
                        <Image src={caracterisation} />
                      </View>
                      <View style={{ marginRight: 2 }}>
                        <Text
                          style={
                            wasteQualityStyleSheet.caracterisationContainer
                          }
                        >
                          {selectedNumberOfCycleMaterial}
                        </Text>
                      </View>
                      <View>
                        <Text
                          style={wasteQualityStyleSheet.caracterisationText}
                        >
                          {t("contenant")}
                        </Text>
                        <Text
                          style={wasteQualityStyleSheet.caracterisationText}
                        >
                          {t("characterized")}
                        </Text>
                      </View>
                    </View>
                  </>
                )}
                {characterizationMassAnalysis ? (
                  <>
                    <Text style={wasteQualityStyleSheet.ChartTitle}>
                      {t("Détail analyse")}
                    </Text>
                    <Text style={wasteQualityStyleSheet.ChartTitle}>
                      {t("massique")}
                    </Text>

                    <View>
                      <Text style={wasteQualityStyleSheet.stats}>
                        {totalWeight
                          ? toFrenchNumber(totalWeight / 1000, 1)
                          : "-"}{" "}
                        {t("tonnes")}
                      </Text>
                      <Text style={wasteQualityStyleSheet.text}>
                        {t("de déchets pesés")}
                      </Text>
                    </View>

                    <View>
                      <Text style={wasteQualityStyleSheet.stats}>
                        {totalMassRecoverable > 0
                          ? toFrenchNumber(
                              (totalMassRecoverable / totalWasteMass) * 100,
                              1,
                            )
                          : "0,0"}{" "}
                        %
                      </Text>
                      <Text style={wasteQualityStyleSheet.text}>
                        {t("de matières")}
                      </Text>
                      <Text style={wasteQualityStyleSheet.text}>
                        {t("valorisables en masse")}
                      </Text>
                    </View>
                  </>
                ) : null}

                {showOutletSection && (
                  <View style={{ marginTop: 20 }}>
                    <View style={wasteQualityStyleSheet.noticeText}>
                      <Text style={wasteQualityStyleSheet.notice}>*</Text>
                      <Text style={wasteQualityStyleSheet.textSmall}>
                        {t(
                          "Pour plus de détails sur les catégories de déchets",
                        )}
                        ,
                      </Text>
                    </View>
                    <Text
                      style={{
                        ...wasteQualityStyleSheet.textSmall,
                        marginLeft: 6,
                      }}
                    >
                      {t("veuillez vous référer à la fin du document")}.
                    </Text>
                  </View>
                )}
              </View>
              {showMassSection && (
                <View
                  style={{
                    flex: 7,
                    height: "300px",
                    width: "350px",
                    alignItems: "flex-end",
                    justifyContent: "flex-start",
                    marginTop: 10,
                  }}
                >
                  {chartImageUrl && (
                    <Image
                      src={chartImageUrl}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </View>
              )}
            </View>
          </View>
          <WasteQualityFooter page={pageCounter++} />
        </Page>
      )}
      {showCombinedDetailsPage && (
        <Page size="A4">
          <HeaderWasteQualityPDF
            caracDatetime={caracDatetime}
            logoUrl={corporationData.logoUrl}
          />
          <View style={{ height: "79%" }}>
            {showVolumeSection && (
              <View style={wasteQualityStyleSheet.volumeContent}>
                <View style={{ flex: 3, marginTop: 40 }}>
                  <Text style={wasteQualityStyleSheet.ChartTitle}>
                    {t("Détail analyse")}
                  </Text>
                  <Text style={wasteQualityStyleSheet.ChartTitle}>
                    {t("volumique")}
                  </Text>

                  <View>
                    <Text style={wasteQualityStyleSheet.stats}>
                      {totalVolumeRecoverable > 0
                        ? toFrenchNumber(
                            (totalVolumeRecoverable / totalWasteVolume) * 100,
                            1,
                          )
                        : "0,0"}{" "}
                      %
                    </Text>
                    <Text style={wasteQualityStyleSheet.text}>
                      {t("de matières")}
                    </Text>
                    <Text style={wasteQualityStyleSheet.text}>
                      {t("valorisables en volume")}
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    flex: 7,
                    height: "300px",
                    width: "350px",
                    alignItems: "flex-end",
                    justifyContent: "flex-start",
                    marginTop: 30,
                  }}
                >
                  {volumeImgData && (
                    <Image
                      src={volumeImgData}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </View>
              </View>
            )}
            {showObjectsSection && (
              <View style={wasteQualityStyleSheet.materialContent}>
                <View style={{ flex: 3, marginTop: 30 }}>
                  <View>
                    <Text style={wasteQualityStyleSheet.ChartTitle}>
                      {t("Détails par")}
                    </Text>
                    <Text style={wasteQualityStyleSheet.ChartTitle}>
                      {t("nombre")}
                    </Text>
                    <Text style={wasteQualityStyleSheet.ChartTitle}>
                      {t("d'objets")}
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    flex: 7,
                    alignItems: "flex-end",
                    justifyContent: "flex-start",
                  }}
                >
                  <View style={wasteQualityStyleSheet.materialChart}>
                    {materialImageUrl && (
                      <Image
                        src={materialImageUrl}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </View>
                </View>
              </View>
            )}
          </View>
          <WasteQualityFooter page={pageCounter++} />
        </Page>
      )}

      {!superContainer
        ? (temporalDataArray || []).map((item, index) => (
            <WasteQualityImageComponent
              key={item._id}
              data={item}
              page={pageCounter++}
              caracDatetime={caracDatetime}
              logoUrl={corporationData.logoUrl}
              container={container}
            />
          ))
        : (temporalDataArray?.[0] || []).map((item, index) => (
            <>
              <WasteQualityImageComponent
                key={item._id}
                data={item}
                page={pageCounter++}
                caracDatetime={caracDatetime}
                logoUrl={corporationData.logoUrl}
                container={container}
                superContainer={superContainer}
              />
              {(temporalDataArray?.[1] || []).filter(
                (i) => i._time === item._time,
              ).length > 0 && (
                <WasteQualityImageComponent
                  key={`${item._id}-b`}
                  data={
                    (temporalDataArray?.[1] || []).filter(
                      (i) => i._time === item._time,
                    )[0]
                  }
                  page={pageCounter++}
                  caracDatetime={caracDatetime}
                  logoUrl={corporationData.logoUrl}
                  container={container}
                  superContainer={superContainer}
                />
              )}
            </>
          ))}

      {showOutletSection && (
        <Page size="A4">
          <HeaderWasteQualityPDF
            caracDatetime={caracDatetime}
            logoUrl={corporationData.logoUrl}
          />
          <View style={{ height: "79%" }}>
            <View style={wasteQualityStyleSheet.volumeContent}>
              <View style={{ flex: 2.6, marginTop: 22 }}>
                <Text style={wasteQualityStyleSheet.ChartTitle}>
                  {t("Détail par")}
                </Text>
                <Text style={wasteQualityStyleSheet.ChartTitle}>
                  {t("filières locales")}
                </Text>

                <View>
                  <Text style={wasteQualityStyleSheet.stats}>
                    {totalMassInOutlet > 0
                      ? toFrenchNumber(
                          (totalMassInOutlet / totalWasteMass) * 100,
                          1,
                        )
                      : "0,0"}{" "}
                    %
                  </Text>
                  <Text style={wasteQualityStyleSheet.text}>
                    {t("de matières")}
                  </Text>
                  <Text
                    style={{ fontSize: 12, fontFamily: "Mulish", marginTop: 3 }}
                  >
                    {t("avec filière")}
                  </Text>
                </View>

                <View>
                  <Text style={wasteQualityStyleSheet.stats}>
                    {totalMassNotInOutlet > 0
                      ? toFrenchNumber(
                          (totalMassNotInOutlet / totalWasteMass) * 100,
                          1,
                        )
                      : "0,0"}{" "}
                    %
                  </Text>
                  <Text style={wasteQualityStyleSheet.text}>
                    {t("de matières")}
                  </Text>
                  <Text style={wasteQualityStyleSheet.text}>
                    {t("sans filière")}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  flex: 7.4,
                  marginTop: 22,
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <View style={{ width: "100%", marginBottom: 10 }}>
                  <Text style={wasteQualityStyleSheet.outletInfoText}>
                    {t(
                      "En complément du décret n° 2021-1199, qui classe les déchets selon leur potentiel de valorisation, cette section propose une analyse des matériaux en fonction des filières locales disponibles.",
                    )}
                  </Text>
                </View>
                {tableOutletImgData && (
                  <View
                    style={{
                      // Pas de hauteur fixe + contain : l'ancien cadre 350x360
                      // letterboxait l'image (blanc en bas, tableau non étiré).
                      // Largeur max de la colonne élargie + hauteur auto = le
                      // tableau grandit réellement en hauteur (aspect conservé).
                      width: "405px",
                      alignSelf: "flex-end",
                    }}
                  >
                    <Image src={tableOutletImgData} style={{ width: "100%" }} />
                  </View>
                )}
              </View>
            </View>

            <View style={wasteQualityStyleSheet.outletRepartition}>
              <View style={{ flex: 3, marginTop: 15 }}>
                <View>
                  <Text style={wasteQualityStyleSheet.ChartTitle}>
                    {t("Répartition par")}
                  </Text>
                  <Text style={wasteQualityStyleSheet.ChartTitle}>
                    {t("filière")}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  flex: 7,
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                }}
              >
                {outletImgData && (
                  <View style={wasteQualityStyleSheet.outletChartImage}>
                    <Image
                      src={outletImgData}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </View>
                )}
              </View>
            </View>
          </View>
          <WasteQualityFooter page={pageCounter++} />
        </Page>
      )}

      {showEprSection && (
        <Page size="A4">
          <HeaderWasteQualityPDF
            caracDatetime={caracDatetime}
            logoUrl={corporationData.logoUrl}
          />
          <View style={{ height: "79%" }}>
            <View
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 20,
              }}
            >
              <Text style={wasteQualityStyleSheet.ChartTitle}>
                {t("Détail par")} {t("REP")}
              </Text>
            </View>
            <View
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                flexDirection: "row",
              }}
            >
              <View style={{ flex: 3, marginTop: 60 }}>
                <View>
                  <Text style={wasteQualityStyleSheet.ChartTitle}>
                    {t("Répartition volumique")}
                  </Text>
                  <Text style={wasteQualityStyleSheet.ChartTitle}>
                    {t("par REP")}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  flex: 7,
                  alignItems: "flex-end",
                  marginTop: 20,
                }}
              >
                {chartRepImgData && (
                  <View
                    style={{
                      width: "350px",
                      height: "300px",
                      alignSelf: "flex-end",
                    }}
                  >
                    <Image
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src={chartRepImgData}
                    />
                  </View>
                )}
              </View>
            </View>

            <View
              style={{
                padding: 10,
                height: "auto",
                alignItems: "center",
                width: "100%",
                bottom: 0,
              }}
            >
              <View
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: 3,
                  borderRadius: 5,
                  width: "100%",
                  flexDirection: "row",
                }}
              >
                <View style={{ padding: 5 }}>
                  <Image src={bulb} style={{ width: "20px", height: "20px" }} />
                </View>
                {repDescriptionDatas.length > 0 && (
                  <View style={{ flexDirection: "column" }}>
                    {repDescriptionDatas.map((item, idx) => (
                      <View
                        style={{ flexDirection: "row", marginTop: 5 }}
                        key={`${item.category}-${idx}`}
                      >
                        <Text style={{ fontSize: 11, marginRight: 5 }}>•</Text>
                        <Text>
                          <Text style={{ fontSize: 9, fontWeight: 700 }}>
                            {item.category} :
                          </Text>
                          <Text style={{ fontSize: 9 }}>
                            {" "}
                            {t(item.descriptions)}
                          </Text>
                        </Text>
                      </View>
                    ))}
                  </View>
                )}
              </View>
            </View>
          </View>
          <WasteQualityFooter page={pageCounter++} />
        </Page>
      )}

      {showSizeDistributionSection && (
        <Page size="A4" wrap={false}>
          <HeaderWasteQualityPDF
            caracDatetime={caracDatetime}
            logoUrl={corporationData.logoUrl}
          />
          <View
            style={{
              width: 571.28,
              alignSelf: "center",
              marginTop: 8,
              paddingBottom: 28,
              flexDirection: "column",
            }}
          >
            <Text style={wasteQualityStyleSheet.ChartTitle}>
              {t("Object size distribution")}
            </Text>
            <View
              style={{
                marginTop: 8,
                paddingVertical: 6,
                paddingHorizontal: 8,
                backgroundColor: "rgba(0, 167, 166, 0.10)",
                borderWidth: 1,
                borderColor: "#00A7A6",
                borderRadius: 4,
              }}
            >
              <Text
                style={{
                  fontSize: 8,
                  fontFamily: "Mulish",
                  color: "#007A79",
                  marginBottom: 3,
                }}
              >
                {t("About this chart")}
              </Text>
              <Text
                style={{
                  fontSize: 6.5,
                  fontFamily: "Mulish",
                  color: "#111827",
                  lineHeight: 1.35,
                }}
              >
                {sizeDistributionThresholdCm === 0
                  ? t("size_distribution_info_no_cutoff")
                  : t("size_distribution_info_configured", {
                      thresholdCm: sizeDistributionThresholdCm,
                    })}
              </Text>
            </View>
            {sizeChartImgData && (
              <Image
                src={sizeChartImgData}
                style={{
                  width: 571.28,
                  height: 168,
                  marginTop: 10,
                }}
              />
            )}
            {sizeMatrixImgData && (
              <Image
                src={sizeMatrixImgData}
                style={{
                  width: 571.28,
                  marginTop: 12,
                  maxHeight: 430,
                }}
              />
            )}
          </View>
          {/* Hors flux : évite que Confidentiel / n° page crée une page vide */}
          <View
            style={{ position: "absolute", bottom: 12, left: 0, right: 0 }}
            fixed
          >
            <WasteQualityFooter page={pageCounter++} />
          </View>
        </Page>
      )}

      {characterizationComments && comments.length > 0 && (
        <Page size="A4">
          <HeaderWasteQualityPDF
            caracDatetime={caracDatetime}
            logoUrl={corporationData.logoUrl}
          />
          <View
            style={{ height: "79%", backgroundColor: "#e5e7eb", padding: 10 }}
          >
            {comments
              .slice() // avoid mutating original
              .reverse()
              .map((item, index) => (
                <View
                  key={index}
                  style={{ display: "flex", flexDirection: "row", gap: 8 }}
                >
                  <View
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      borderRadius: 50,
                      backgroundColor: "#00A7A6",
                      height: 32,
                      width: 32,
                      overflow: "hidden",
                      color: "#ffffff",
                    }}
                  >
                    <Image
                      src={userIcon}
                      style={{ height: 15, width: 15, objectFit: "cover" }}
                    />
                  </View>
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#ffffff",
                      borderRadius: 6,
                      paddingLeft: 12,
                      paddingRight: 12,
                      paddingTop: 8,
                      paddingBottom: 8,
                      width: "100%",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <View
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: 8,
                        }}
                      >
                        <Text style={{ color: "#00A6A7" }}>
                          {getCommentAuthorName(item?.author)}
                        </Text>
                        <Text style={{ color: "#6B7280" }}>
                          {formattedDate(item.time, t)} -{" "}
                          {formattedTime(item.time)}
                        </Text>
                      </View>
                    </View>
                    <Text
                      style={{ color: "#6B7280", marginTop: 8, fontSize: 13 }}
                    >
                      {item.text}
                    </Text>
                  </View>
                </View>
              ))}
          </View>
          <WasteQualityFooter page={pageCounter++} />
        </Page>
      )}
    </Document>
  );
};

export default WasteQualityPDF;
